import PageMeta from "../components/PageMeta";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section
      className="py-10 lg:py-20 h-screen"
      style={{
        background:
          "url('/images/covers/404-bg.webp') no-repeat center center / cover",
      }}
    >
      <PageMeta
        title="404 - Page Not Found | CV Box - AI CV Optimizer"
        description="The page you're looking for doesn't exist. Return to CV Box to optimize your CV with AI, get free ATS analysis, and track job applications with smart tools."
      />
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        <div className="max-w-xl mx-auto text-center mb-10 lg:mb-20">
          <h1 className="text-4xl lg:text-5xl -tracking-[1.9px] mb-4 font-medium text-gray-900">
            Oops! Something went wrong
          </h1>

          <p className="text-base text-gray-500 mb-9 lg:px-5">
            The page you're looking for isn't here. Try searching or browsing
            our others pages for your needed info.
          </p>
          <Link
            to="/"
            className="inline-block py-3 px-6 bg-indigo-500 hover:bg-indigo-600 text-white font-medium rounded-lg transition-all shadow-sm hover:shadow-md"
          >
            Go Back Home
          </Link>
        </div>
        <div className="flex justify-center ">
          <svg
            width={719}
            height={288}
            viewBox="0 0 719 288"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <foreignObject x="-37.2" y="-37.2" width="792.762" height="362.4">
              <div
                xmlns="http://www.w3.org/1999/xhtml"
                style={{
                  backdropFilter: "blur(18.6px)",
                  clipPath: "url(#bgblur_0_15171_3331_clip_path)",
                  height: "100%",
                  width: "100%",
                }}
              />
            </foreignObject>
            <path
              data-figma-bg-blur-radius="37.2"
              d="M-0.000194967 184L99.5998 3.99998H151.6L49.5998 184H-0.000194967ZM-0.000194967 212V184L19.5998 170.8H217.2V212H-0.000194967ZM132.8 284V100.8H178V284H132.8ZM359.653 288C338.586 288 319.253 282.133 301.653 270.4C284.32 258.4 270.453 241.6 260.053 220C249.653 198.4 244.453 172.933 244.453 143.6C244.453 114.267 249.52 88.9333 259.653 67.6C270.053 46 283.92 29.3333 301.253 17.6C318.586 5.86666 337.786 -1.52588e-05 358.853 -1.52588e-05C380.186 -1.52588e-05 399.52 5.86666 416.853 17.6C434.186 29.3333 447.92 46 458.053 67.6C468.453 88.9333 473.653 114.4 473.653 144C473.653 173.333 468.453 198.8 458.053 220.4C447.92 242 434.186 258.667 416.853 270.4C399.786 282.133 380.72 288 359.653 288ZM358.853 244.8C372.72 244.8 384.72 241.067 394.853 233.6C404.986 226.133 412.853 214.933 418.453 200C424.32 185.067 427.253 166.267 427.253 143.6C427.253 121.2 424.32 102.533 418.453 87.6C412.853 72.6666 404.853 61.6 394.453 54.4C384.32 46.9333 372.453 43.2 358.853 43.2C345.253 43.2 333.253 46.9333 322.853 54.4C312.72 61.6 304.853 72.6666 299.253 87.6C293.653 102.267 290.853 120.933 290.853 143.6C290.853 166.267 293.653 185.067 299.253 200C304.853 214.933 312.72 226.133 322.853 233.6C333.253 241.067 345.253 244.8 358.853 244.8ZM501.162 184L600.762 3.99998H652.762L550.762 184H501.162ZM501.162 212V184L520.762 170.8H718.362V212H501.162ZM633.962 284V100.8H679.162V284H633.962Z"
              fill="white"
              fillOpacity="0.44"
            />
            <defs>
              <clipPath
                id="bgblur_0_15171_3331_clip_path"
                transform="translate(37.2 37.2)"
              >
                <path d="M-0.000194967 184L99.5998 3.99998H151.6L49.5998 184H-0.000194967ZM-0.000194967 212V184L19.5998 170.8H217.2V212H-0.000194967ZM132.8 284V100.8H178V284H132.8ZM359.653 288C338.586 288 319.253 282.133 301.653 270.4C284.32 258.4 270.453 241.6 260.053 220C249.653 198.4 244.453 172.933 244.453 143.6C244.453 114.267 249.52 88.9333 259.653 67.6C270.053 46 283.92 29.3333 301.253 17.6C318.586 5.86666 337.786 -1.52588e-05 358.853 -1.52588e-05C380.186 -1.52588e-05 399.52 5.86666 416.853 17.6C434.186 29.3333 447.92 46 458.053 67.6C468.453 88.9333 473.653 114.4 473.653 144C473.653 173.333 468.453 198.8 458.053 220.4C447.92 242 434.186 258.667 416.853 270.4C399.786 282.133 380.72 288 359.653 288ZM358.853 244.8C372.72 244.8 384.72 241.067 394.853 233.6C404.986 226.133 412.853 214.933 418.453 200C424.32 185.067 427.253 166.267 427.253 143.6C427.253 121.2 424.32 102.533 418.453 87.6C412.853 72.6666 404.853 61.6 394.453 54.4C384.32 46.9333 372.453 43.2 358.853 43.2C345.253 43.2 333.253 46.9333 322.853 54.4C312.72 61.6 304.853 72.6666 299.253 87.6C293.653 102.267 290.853 120.933 290.853 143.6C290.853 166.267 293.653 185.067 299.253 200C304.853 214.933 312.72 226.133 322.853 233.6C333.253 241.067 345.253 244.8 358.853 244.8ZM501.162 184L600.762 3.99998H652.762L550.762 184H501.162ZM501.162 212V184L520.762 170.8H718.362V212H501.162ZM633.962 284V100.8H679.162V284H633.962Z" />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
    </section>
  );
}
